import "./FileViewer.css";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Document, Page, pdfjs } from "react-pdf";
import React, { memo, useEffect, useRef, useState } from "react";

import DXFFileViewer from "./DXFFileViewer";
import Iframe from "react-iframe";
import STEPFileViewer from "./STEPFileViewer";
import STLFileViewer from "./STLFileViewer";

const FileViewerComponent = ({ disableHeader, path, type, folderType }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  let filePath = path ? path : localStorage.getItem("filePath");
  console.log("filepath----", filePath);
  const fileType = type ? type : localStorage.getItem("fileType");
  const imageFileTypeArray = ["jpg", "png", "jpeg"];
  const videoFileTypeArray = ["mp4", "mkv", "webm"];
  const cadFileTypeArray = ["step", "stp"];

  const isPdf = fileType?.toLowerCase()?.toString() === "pdf";
  const isVideo = videoFileTypeArray.includes(
    fileType?.toLowerCase()?.toString()
  );
  const isImage = imageFileTypeArray.includes(
    fileType?.toLowerCase()?.toString()
  );
  const isCADSTEP = cadFileTypeArray.includes(
    fileType?.toLowerCase()?.toString()
  );
  const isExcel =
    fileType?.toLowerCase() === "xls" ||
    fileType?.toLowerCase() === "xlsx";

  const isCADSTL = fileType?.toLowerCase()?.toString() === "stl";
  const isCADDXF = fileType?.toLowerCase()?.toString() === "dxf";
  const isHeaderDisabled = disableHeader || false;

  const isWord = fileType?.toLowerCase()?.toString() === "doc" || fileType?.toLowerCase()?.toString() === "docx";
  const isPPTX =
    fileType?.toLowerCase()?.toString() === "ppt" ||
    fileType?.toLowerCase()?.toString() === "pptx";
  if (folderType === "webLink") {
    if (path?.includes("youtube.com") && path?.includes("watch?v="))
      filePath = path?.replace("watch?v=", "embed/");
    if (path?.includes("youtu.be")) {
      const code = path?.split("/").pop();
      filePath = `https://www.youtube.com/embed/${code}`;
    }
  }

  const [numPages, setNumPages] = useState(null);

  const docs = [{ uri: filePath, fileType: fileType }];

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const [pageNumber, setPageNumber] = useState(1);
  const [zoom, setZoom] = useState(1); // default zoom
  const [inputValue, setInputValue] = useState(pageNumber);

  // Keep input in sync when user scrolls normally
  useEffect(() => {
    setInputValue(pageNumber);
  }, [pageNumber]);

  const handleJump = () => {
    let val = parseInt(inputValue, 10);
    if (!isNaN(val)) {
      if (val < 1) val = 1;
      if (val > numPages) val = numPages;

      setPageNumber(val);

      const element = document.getElementById(`page_${val}`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(800);

  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, []);
  const [renderZoom, setRenderZoom] = useState(zoom);

  useEffect(() => {
    const timeout = setTimeout(() => setRenderZoom(zoom), 200); // update after 200ms
    return () => clearTimeout(timeout);
  }, [zoom]);
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const pageEls = Array.from(document.querySelectorAll(".pdf-page"));

    let currentPage = 1;
    for (let i = 0; i < pageEls.length; i++) {
      if (pageEls[i].offsetTop <= scrollTop + 60) {
        currentPage = i + 1; // pages are 1-based
      } else {
        break;
      }
    }

    setPageNumber(currentPage);
  };

  return (
    <div
      className="file-view-documents"
      style={{
        display: isVideo && "flex",
        justifyContent: isVideo && "center",
      }}
    >
      {folderType === "webLink" ? (
        <Iframe
          url={filePath}
          width="100%"
          height="100%"
          id="filePath"
          frameBorder={0}
          display="block"
          position="relative"
        />
      ) : isPdf ? (
        <Iframe
          url={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(filePath)}`}
          width="100%"
          height="100%"
        />
        //        <div className="pdf-viewer-layout">
        //   {/* Sidebar with thumbnails - hide on small screens */}
        //   <div className="pdf-thumbnails">
        //     <Document file={filePath} onLoadSuccess={onDocumentLoadSuccess}>
        //       {Array.from(new Array(numPages), (_, index) => (
        //         <div
        //           key={index}
        //           className={`thumbnail-wrapper ${
        //             pageNumber === index + 1 ? "active" : ""
        //           }`}
        //           onClick={() => {
        //             const targetPage = index + 1;
        //             setPageNumber(targetPage);
        //             const element = document.getElementById(`page_${targetPage}`);
        //             if (element) {
        //               element.scrollIntoView({
        //                 behavior: "smooth",
        //                 block: "start",
        //               });
        //             }
        //           }}
        //         >
        //           <Page
        //             pageNumber={index + 1}
        //             width={140}
        //             renderAnnotationLayer={false}
        //             renderTextLayer={false}
        //           />
        //           <span className="thumbnail-page-number">{index + 1}</span>
        //         </div>
        //       ))}
        //     </Document>
        //   </div>

        //   {/* Main PDF viewer */}
        //   <div className="pdf-main">
        //     {/* Controls pinned at top */}
        //     <div className="pdf-controls">
        //       <div className="page-jump">
        //         <label>
        //           Page{" "}
        //           <input
        //             type="number"
        //             min={1}
        //             max={numPages}
        //             value={inputValue}
        //             onChange={(e) => setInputValue(e.target.value)}
        //             onKeyDown={(e) => {
        //               if (e.key === "Enter") handleJump();
        //             }}
        //             onBlur={handleJump}
        //             className="page-input"
        //           />{" "}
        //           of {numPages}
        //         </label>
        //       </div>

        //       <div className="zoom-controls">
        //         <button
        //           className="zoom-btn"
        //           onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}
        //         >
        //           -
        //         </button>
        //         <span className="zoom-display">{Math.round(zoom * 100)}%</span>
        //         <button
        //           className="zoom-btn"
        //           onClick={() => setZoom((z) => z + 0.2)}
        //         >
        //           +
        //         </button>
        //       </div>
        //     </div>

        //     {/* Scrollable main PDF area */}
        //   <div
        //   className="pdf-page-container"
        //   ref={containerRef}
        //   onScroll={handleScroll}   // ✅ now using the extracted function
        // >
        //   <Document file={filePath} onLoadSuccess={onDocumentLoadSuccess}>
        //     {Array.from(new Array(numPages), (_, index) => (
        //       <div
        //         key={index}
        //         id={`page_${index + 1}`}
        //         className="pdf-page"
        //         style={{
        //           transform: `scale(${zoom})`,
        //           transformOrigin: "top center",
        //           marginBottom: `${20 * zoom}px`,
        //         }}
        //       >
        //         <Page pageNumber={index + 1} width={containerWidth} />
        //       </div>
        //     ))}
        //   </Document>
        // </div>



        //   </div>
        // </div>






      ) : isVideo ? (
        <video
          src={filePath}
          style={{
            width: "95%",
            maxWidth: "1300px",
          }}
          autoPlay
          controls
          controlsList="nodownload"
        ></video>
      ) : isCADSTEP ? (
        <STEPFileViewer fileUrl={filePath} />
      ) : isCADSTL ? (
        <STLFileViewer fileUrl={filePath} />
      ) : isCADDXF ? (
        <DXFFileViewer fileUrl={filePath} />
      ) : isWord ? (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(filePath)}&embedded=true`}
          style={{
            width: "100%",
            height: "100vh",
            border: "none"
          }}
        />

      ) : isPPTX ? (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(
            filePath
          )}&embedded=true`}
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
          }}
        />
      ) : isExcel ? (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(filePath)}`}
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
          }}
        />

      ) : (
        <>
          <DocViewer
            documents={docs}
            pluginRenderers={DocViewerRenderers}
            style={{ height: "100vh" }}
            config={{
              header: {
                disableHeader: isHeaderDisabled,
                disableFileName: isHeaderDisabled,
                retainURLParams: isHeaderDisabled,
              },
            }}
          />
          {!isImage && <div className="empty-container" />}
        </>
      )}
    </div>
  );
};

export default memo(FileViewerComponent);
